import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Rule } from '../../interfaces/Rule';
import { RulesetEngine } from '../ruleset_engine/RulesetEngine';
import { EnumFeatureType } from '../../../../../../../constants';

export class IsPGLoan implements Rule {
  public evaluate(data: Partial<ApplicationFormValues>): boolean {
    const isPGLoan = RulesetEngine.evaluate(
      EnumFeatureType.PG,
      data as ApplicationFormValues
    );

    const anyPrincipalIsPG =
      data.principals?.some(
        (principal) => principal.principal_is_personal_guarantor === 'Yes'
      ) ?? false;

    return isPGLoan || anyPrincipalIsPG;
  }
}

export default new IsPGLoan();
